import PropTypes from 'prop-types';

export const masterDataItemPropType = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
});

export const seasonPropType = masterDataItemPropType;

export const countryPropType = masterDataItemPropType;

export const destinationPropType = masterDataItemPropType;

export const jobTitlePropType = masterDataItemPropType;

export const keywordPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  keyword: PropTypes.string.isRequired,
  active: PropTypes.bool,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
});

export const templatePropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  active: PropTypes.bool,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
});

export const templateOptionPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  templateId: PropTypes.number.isRequired,
  optionText: PropTypes.string.isRequired,
  active: PropTypes.bool,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
});
